import React, { useState, useEffect } from "react";
import { Form, Button, Dropdown } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { map } from "lodash";

export function FormAlumnosBajas(props) {
  const { alumno } = props;
  console.log(alumno);
  const [refetch] = useState(false);
  const { auth } = useAuth();
  const [grupos, setGrupos] = useState(null);
  const [grupoFormato, setGrupoFormato] = useState([]);
  const [grupo, setGrupo] = useState(null);
  const [loading, setLoading] = useState(true);

  async function getGruposApi() {
    try {
      const response = await axios.get(`${BASE_API}/api/grupo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setGrupos(result);
      return result;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getGruposApi();
    // eslint-disable-next-line
  }, [refetch]);

  useEffect(() => {
    setGrupoFormato(formatoDelDropDown(grupos));
  }, [grupos]);

  async function getGrupoApi(grupo_id) {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_API}/api/grupo/${grupo_id}/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setGrupo(result);
      setLoading(false);
      return result;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  async function updateGrupo(grupoId, nuevoAlumnoId, dataGrupo) {
    //await eliminarAlumnoDelGrupoAntiguo(nuevoAlumnoId);
    try {
      const url = `${BASE_API}/api/grupo/${grupoId}/`;
      const headers = {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      };
      const alumnosIds = dataGrupo.alumnos.map((alumno) => parseInt(alumno));
      const nuevaListaAlumnosIds = [...alumnosIds, parseInt(nuevoAlumnoId)];
      const data = {
        numero_grupo: dataGrupo.numero_grupo,
        capacidad: dataGrupo.capacidad,
        alumnos: nuevaListaAlumnosIds,
      };

      const response = await axios.put(url, data, { headers });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  const updateAlumno = async (alumnoId, data) => {
    try {
      await updateAlumnoApi(alumnoId, data, auth.token);
      return alumnoId; // Devolver el ID del alumno actualizado
    } catch (error) {
      throw error;
    }
  };

  async function updateAlumnoApi(id, data) {
    try {
      const url = `${BASE_API}/api/alumno/${id}/`;
      const headers = {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.patch(url, data, { headers });
      toast.success("Datos actualizados exitosamente");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  const estadoAlumno = [
    { key: "1", text: "Activo", value: "Activo" },
    { key: "2", text: "Baja temporal", value: "Baja temporal" },
    { key: "3", text: "Baja definitiva", value: "Baja definitiva" },
  ];

  useEffect(() => {
    const setInitialValues = async () => {
      if (grupos !== null) {
        formik.setValues(initialValues(alumno, grupos));
      }
    };
    setInitialValues();
  }, [alumno, grupos]);

  const formik = useFormik({
    initialValues: {},
    validationSchema: Yup.object(updateSquema()),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        let alumnoId;
        if (alumno) {
          await updateAlumno(alumno.id, formValue);
          alumnoId = alumno.id;
        } else {
          console.log("no encontrado");
        }
        if (formValue.estado_alumno === "Activo" && formValue.grupo) {
          const grupoData = await getGrupoApi(formValue.grupo);
          await updateGrupo(formValue.grupo, alumnoId, grupoData);
        }
        window.location.reload();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <>
      <div className="divcampo">
        <label className="campR">
          Campo requerido <span className="astedisco">*</span>
        </label>
      </div>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <label>
          Estado del alumno <span className="astedisco">*</span>
        </label>
        <Dropdown
          placeholder="Estado alumno"
          fluid
          selection
          search
          options={estadoAlumno}
          value={formik.values.estado_alumno}
          error={formik.errors.estado_alumno}
          onChange={(_, datos) => {
            formik.setFieldValue("estado_alumno", datos.value);
          }}
        />
        {formik.values.estado_alumno === "Activo" && (
          <div>
            <label>
              Grupo <span className="astedisco">*</span>
            </label>
            <Dropdown
              placeholder="Grupo"
              fluid
              selection
              search
              options={grupoFormato}
              value={formik.values.grupo}
              error={formik.errors.grupo}
              onChange={(_, datos) => {
                formik.setFieldValue("grupo", datos.value);
              }}
            />
          </div>
        )}
        <Button
          type="submit"
          content={alumno ? "Actualizar" : "Crear"}
          className="botonEnviar"
          fluid
        />
      </Form>
      <ToastContainer />
    </>
  );
}

function formatoDelDropDown(informacionGrupos) {
  return map(informacionGrupos, (item) => ({
    key: item.id_grupo,
    text: item.numero_grupo,
    value: item.id_grupo,
  }));
}

function initialValues(datoAlumno, grupos) {
  let grupoAlumno = null;
  if (datoAlumno && grupos) {
    grupos.forEach((grupo) => {
      if (grupo.alumnos.includes(datoAlumno.id)) {
        grupoAlumno = grupo;
      }
    });
  }
  return {
    grupo: grupoAlumno?.id_grupo || "",
    estado_alumno: datoAlumno?.estado_alumno || "",
  };
}

function updateSquema() {
  return {
    // grupo: Yup.string().required(true),
  };
}
